<template>
  <!-- 库房管理 -->
  <div class="container_wh">
    <div class="main_wh">
      <div class="content_left">
        <template v-if="ckTab.length > 0">
          <template v-for="(item,index) in ckTab">
            <div :key="index" :class="ckVal==item.id ? 'select-buttom' : ''" class="ckbtns" @click="stores(item.id, index)">{{ item.depotName }}
            </div>
          </template>
        </template>
        <div @click="addstore" class="ckbtns select-buttom addbtn el-icon-plus">新增仓库</div>
      </div>
      <div class="content_right">
        <div class="btns_wh">
          <div class="b_header">
            <div>
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>库房管理</el-breadcrumb-item>
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="cat-tab" v-if="ckTab.length > 0">
            <div class="left_btn">
              <div class="my-buttom"  @click="yqChange(0)":class="Eqorpower==0? 'select-buttom' : ''">仪 器 柜</div>
              <div class="my-buttom" v-if="isOpenPower" @click="yqChange(1)"  :class="Eqorpower==1 ? 'select-buttom' : ''">电源控制器</div>
              <div class="my-buttom" @click="yqChange(2)"  :class="Eqorpower==2 ? 'select-buttom' : ''">货架列表</div>
            </div>
              <div class="center_btn">
            <div v-if="ckTab.length > 0&&Eqorpower!=2" class="ck-info">
              <div class='gzNumber'>
                <div class="icon-bg"><i class="iconfont icon-iconset0499"></i></div>
                <span> 智能柜：{{ ckTab[selectCK].cabinetCount ? ckTab[selectCK].cabinetCount : '0' }}</span>
              </div>
              <div class='gzNumber'>
                <div class="icon-bg"><i class="iconfont icon-guizi"></i></div>
                <span>位置：{{ ckTab[selectCK].using ? ckTab[selectCK].using : '0' }}/{{ ckTab[selectCK].total ? ckTab[selectCK].total : '0' }}</span>
              </div>
              <div class='gzNumber' v-if="isOpenPower">
                <div class="icon-bg"><i class="iconfont icon-dianyuan-copy"></i></div>
                <span>电源控制器：{{ ckTab[selectCK].powerInUse }}/{{ ckTab[selectCK].powerCount }}</span>
              </div>
              <div v-if="ckTab.length > 0" class='gzNumber wd'>
                <div @click="addWd" class="icon-bg"><i class="iconfont icon-wendu"></i></div>
                <span @click="showWd" v-if="ckTab[selectCK].thermometerData != null || ckTab[selectCK].thermometerData != undefined">
                  <span>温度：{{ ckTab[selectCK].thermometerData.temperature }}℃ &nbsp;</span>/&nbsp;
                  <span>&nbsp;湿度：{{ ckTab[selectCK].thermometerData.humidity }}%</span>
                </span>
                <span @click="showWd" v-else>
                  <span> 暂无温湿度信息</span>
                </span>
              </div>
            </div>
            <div class="rith_btn">
              <div class="my-buttom select-buttom el-icon-plus" @click="addmachine" v-if="Eqorpower==0||Eqorpower==1">{{Eqorpower==0?'新增仪器柜':'新增电源控制器'}}</div>
              <div class="my-buttom select-buttom el-icon-plus" @click="editemachine" v-if="Eqorpower==0||Eqorpower==1">{{Eqorpower==0?'编辑仪器柜':'编辑电源控制器'}}</div>
              <div class="my-buttom select-buttom el-icon-plus" @click="delModel" v-if="Eqorpower==0">删除仪器柜</div>
              <div class="my-buttom select-buttom el-icon-edit" @click="edit">仓库编辑</div>
              <div class="my-buttom select-buttom el-icon-view" @click="showHkiMonitor">库内监控</div>
            </div>
          </div>
          </div>
        </div>
        <!-- 柜子 -->
        <template v-if="Eqorpower==0">
          <div class="gz" v-loading.fullscreen.lock='loading' element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)" v-if="ckTab.length > 0">
            <transition name="fade" mode="out-in">
              <gzSwiper :DepotInfo='ckTab[selectCK]' :CabinetList='CabinetList' ref="gzSw" @checkListChose="checkListChose"></gzSwiper>
            </transition>
          </div>
          <div v-else class="not_info">
            <div class="info_text">当前公司尚未配置仓库！</div>
          </div>
        </template>
        <!-- 电源控制器 -->
        <template v-if="Eqorpower==1">
          <div class="gz">
            <!-- <transition name="fade" mode="out-in"> -->
              <transition name="el-zoom-in-center">
              <powerSwiper :depotInfo='ckTab[selectCK]' ref="powerSon"></powerSwiper>
            </transition>
          </div>
        </template>
        <!-- 货柜列表首页 -->
        <template v-if="Eqorpower==2">
          <div class="gz">
            <transition name="el-zoom-in-center">
              <component :is="comName" :depotInfo='ckTab[selectCK]' @change="changeName" :childData="childData"></component>
            </transition>
          </div>
        </template>
      </div>
    </div>
    <!-- 编辑设备-仪器柜 -->
    <div class="popout" v-if="ckTab.length > 0">
      <el-dialog title="编辑" v-if="editeVisible" :visible.sync="editeVisible" width="500px" :close-on-click-modal="false">
        <edit-model @cancel="cancel"  @submit="submitEdit" :checkListChoseL="checkListChoseL"></edit-model>
      </el-dialog>
    </div>
    <!-- 新增设备-仪器柜 -->
    <div class="popout" v-if="ckTab.length > 0">
      <el-dialog title="添加" v-if="addVisible" :visible.sync="addVisible" width="500px" :close-on-click-modal="false">
        <add-model @cancel="cancel" @submit="submit"></add-model>
      </el-dialog>
    </div>
    <!-- 新增设备-电源控制器 -->
    <div class="popout" v-if="ckTab.length > 0">
      <el-dialog title="添加" :visible.sync="addPowerVisible" width="500px" :close-on-click-modal="false">
        <add-power @cancel="cancel" @submit="submit" :myShow="addPowerVisible"></add-power>
      </el-dialog>
    </div>
    <!-- 新增仓库 -->
    <div class=" popout popout2">
      <el-dialog title :visible.sync="dialogFormVisible" v-if="dialogFormVisible" width="1200px" center :close-on-click-modal="false">
        <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="仓库信息配置" name="first">
      <add-warehouse  :propsForm="propsForm" @cancel="dialogFormVisible = false"  :activeName="activeName" @submit="submitWarehouse" :deptId='deptId' :depotInfos='depotInfos'></add-warehouse>
    </el-tab-pane>
    <el-tab-pane label="硬件配置" name="second">
      <add-warehouse  :propsForm="propsForm" @cancel="dialogFormVisible = false"  :activeName="activeName" @submit="submitWarehouse" :deptId='deptId' :depotInfos='depotInfos'></add-warehouse>
    </el-tab-pane>
  </el-tabs>
      </el-dialog>
    </div>
    <!-- 温湿度添加 -->
    <div class="popout" v-if="ckTab.length > 0">
      <el-dialog :visible.sync="ThermVisible" width="500px" v-if="ThermVisible" :modal-append-to-body="false" :close-on-click-modal="false">
        <addTemperature @cancel="cancel" @submitTherm="submitTherm"></addTemperature>
      </el-dialog>
    </div>

    <!-- 温湿度时程曲线图 -->
    <div class="" v-if="thVisible">
      <el-dialog :visible.sync="thVisible" width="1000px" v-if="thVisible" :modal-append-to-body="false">
        <chartModel :chartModal="chartModal" @cancel="thCancel" @submit="thSubmit"></chartModel>
      </el-dialog>
    </div>

    <!--    库内监控-->
    <div class="" v-if="hkiMonModel.visible">
      <el-dialog title="库内监控" :visible.sync="hkiMonModel.visible" width="1000px">
        <monitor-model :data-detail="hkiMonModel.current"></monitor-model>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import addModel from "./components/addModel";
import addPower from "./components/addPower";
import addWarehouse from "./components/addWarehouse";
import editWarehouse from "./components/editWarehouse";
import addTemperature from "./components/addTemperature";
import gzSwiper from "./components/gzSwiper";
import powerSwiper from "./components/powerSwiper";
import chartModel from "./components/chartModel";
import monitorModel from "./components/monitorModel";
import editModel from "./components/editModel.vue";
import containerSwiper from "./components/containerSwiper";
import childContainerSwiper from "./components/childContainerSwiper";
import {
  getDepotInfo,
  getCabinetInfo,
  createCabinet,
  createPower,
  createDepot,
  getDepot,
  updateAsysnc,
  getThermInfo,
  createTherm,
  updateTherm,
  cabinetUpdate,
  cabinetDelete,
} from "@/api/warehouse";
export default {
  components: {
    editModel,
    addModel,
    addWarehouse,
    gzSwiper,
    editWarehouse,
    powerSwiper,
    addTemperature,
    addPower,
    chartModel,
    monitorModel,
    containerSwiper,
    childContainerSwiper,
  },
  data() {
    return {
      propsForm: {},
      activeName: 'first',
      childData:null,
      editeVisible:false, // 编辑仪器柜弹窗
      addVisible: false, //新增仪器柜弹窗
      addPowerVisible: false, //新增电源控制器弹窗
      PowerVisible: false, //新增电源控制器弹窗
      ThermVisible: false, //温湿度添加、编辑弹窗
      dialogFormVisible: false, //添加仓库弹窗
      editFormVisible: false, //编辑仓库弹窗
      thVisible: false, //温湿度时程曲线
      loading: false,
      ckVal: "1", //默认选中仓库
      ckTab: [], //仓库列表
      Eqorpower: 0, //仪器柜、电源控制器切换
      isAdd: false, //是否新增
      deptId: "", //部门id
      depotId: "", //仓库id
      CabinetList: [], //柜子列表
      checkListChoseL:[],
      depotInfos: {}, //当前仓库信息
      selectCK: 0,
      chartModal: {},
      comName: "containerSwiper", //当前组件名称
      hkiMonModel: {
        visible: false,
        current: {},
      },
      isOpenPower: false,
    };
  },
  created() {
    this.deptId = this.$store.state.user.userInfo.deptId;
    this.ckTab = this.$store.state.user.depotList
      ? this.$store.state.user.depotList
      : [];
    if (this.ckTab.length > 0) {
      this.ckVal = this.$store.state.user.depotList[0].id;
      sessionStorage.setItem("depotId", this.ckVal);
      this.getCabinetList();
    }
    this.isOpenPower = this.$store.state.user.modulePower.openPower;
  },
  mounted() {
    if (this.ckTab.length > 0) {
      this.getTInfo();
    }
  },
  methods: {
    handleClick(tab, event) {
      },
    changeName(data,name){
       this.comName = name
       this.childData = data
    },
    yqChange(index) {
        this.Eqorpower = index;
        if(index==2){
          this.comName = 'containerSwiper'
        }
    },
    //checkListChose 仪器柜
    checkListChose(value){
      this.checkListChoseL = this.CabinetList.filter(item => item.id === value);
    },
    //获取仓库信息
    getDepotList() {
      let paeams = { deptId: this.deptId };
      getDepotInfo(paeams).then((res) => {
        this.ckTab = res.data;
        // this.ckVal = res.data[0].id
        sessionStorage.setItem("depotId", this.ckVal);
        this.$store.dispatch("setDepotList", res.data);
      });
    },
    //获取仪器柜信息
    getCabinetList() {
      this.loading = true;
      getCabinetInfo(this.ckVal)
        .then((res) => {
          if (res.data && res.code == "200") {
            // let list = res.data.reverse()
            this.CabinetList = res.data;
            this.$store.dispatch("setCabinetInfo", res.data);
          } else {
            this.CabinetList = [];
          }
          this.loading = false;
        })
        .catch((err) => {
          this.CabinetList = [];
          this.loading = false;
          this.$message.error(err.msg || err.message || "网络请求错误");
        });
    },
    //新增温湿度传感器弹窗
    addWd() {
      this.ThermVisible = true;
    },
    showWd() {
      this.chartModal.depotId = this.ckVal;
      this.thVisible = true;
    },
    //获取温湿度传感器信息
    getTInfo() {
      sessionStorage.removeItem("ThermInfo");
      getThermInfo(this.ckVal).then((res) => {
        if (res.code == 200) {
          sessionStorage.setItem("ThermInfo", JSON.stringify(res.data));
        }
      });
    },
    //仓库切换
    stores(e, index) {
      this.selectCK = index;
      this.ckVal = e;
      sessionStorage.setItem("depotId", this.ckVal);
      this.getCabinetList();
      this.getTInfo();
    },

    //新增仓库弹窗
    addstore() {
      this.depotInfos = {};
      this.isAdd = true;
      this.activeName='first',
      this.dialogFormVisible = true;
      this.propsForm = {
        pictureLink:null,
        sn: '',
        depotName: "", //仓库名称
        address: "",  //地址
        picture: '', //图片路径
        remark: "",//备注
        deptId: '',//单位id
        range: 0,  //柜子数量
        latitude: '',//纬度
        longitude: '',//经度
        location: null,
        isThermometer: false,
        isEquipment: false,
        openDeliver: 0,//是否使用线下交接 
        isNeedApprove: 0,//是否审批
        thermometerList: [
          { thermometerName: '', eui: '' }
        ],
        equipmentList: [{ channelName: '', channelNo: '', deviceSerial: '', }],
        node: [
          {
            userId: null,
          }
        ],
      };
    },
    //新增设备弹窗
    addmachine() {
      if (this.Eqorpower==0) {
        this.addVisible = true;
      } else if(this.Eqorpower==1){
        this.addPowerVisible = true;
      }
    },

    //仪器柜编辑
    editemachine(){
      if(this.checkListChoseL[0] === null || this.checkListChoseL[0] === undefined || this.checkListChoseL[0] === []){
        return this.$message.error('未选择仪器柜子!')
      }
        this.editeVisible = true;
    },

    //新增设备提交
    submit(data, n) {
      if (n == 1) {
        createCabinet(data).then((res) => {
          if (res.code == "200") {
            this.addVisible = false;
            this.getDepotList();
            this.getCabinetList();
            this.$message.success("新增柜子成功！");
          } else {
            this.$message.error("新增柜子失败！" + res.msg);
          }
        });
      } else {
        createPower(data).then((res) => {
          if (res.code == "200") {
            this.addPowerVisible = false;
            this.getDepotList();
            this.$refs.powerSon.getPowerList();
            this.$message.success("新增电源控制器成功！");
          } else {
            this.$message.error("新增电源控制器失败！" + res.msg);
          }
        });
      }
    },
    // 提交编辑功能
    submitEdit(e){
      cabinetUpdate(e).then((res)=>{
        if (res.code == "200") {
          this.editeVisible = false;
          this.getDepotList();
          this.getCabinetList();
          this.checkListChoseL[0] = null
          this.$refs.gzSw.checkList = []
          this.$message.success("仪器柜更新成功！");
        } else {
          this.$message.error("仪器柜更新失败！" + res.msg);
        }
      })
    },
    // 删除仪器柜功能
    delModel() {
      if(this.checkListChoseL[0] === null || this.checkListChoseL[0] === undefined || this.checkListChoseL[0] === []){
        return this.$message.error('未选择仪器柜子!')
      }

      this.$confirm(`确定删除仪器柜： <strong style="color: #fffe4f">${this.checkListChoseL[0].name}</strong> 仪器柜吗?`, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning',
      }).then(() => {
        cabinetDelete(this.checkListChoseL[0].id).then(res=>{
          if (res.code == "200") {
            this.getDepotList();
            this.getCabinetList();
            this.checkListChoseL[0] = null
            this.$message.success("仪器柜删除成功！");
          } else {
            this.$message.error("仪器柜删除失败！" + res.msg);
          }
        })
      }).catch(() => {});
    },

    cancel() {
      this.addVisible = false;
      this.ThermVisible = false;
      this.addPowerVisible = false;
      this.editeVisible = false;
    },
 
    //新增及编辑仓库信息提交
    submitWarehouse(item, isadd) {
      let params ={
        ...item 
      }
      if(item.isEquipment==false){
        params.equipmentList = []
      }
      if(item.isThermometer==false){
        params.thermometerList = []
      }
      if (this.isAdd) {
      
        createDepot(params).then((res) => {
          if (res.code == "200") {
            this.getDepotList();
            this.dialogFormVisible = false;
            this.$message.success(`新增仓库成功！`);
          } else {
            this.$message.error(`新增仓库失败！` + res.msg);
          }
        });
      } else {
        updateAsysnc(params).then((res) => {
          if (res.code == "200") {
            this.getDepotList();
            this.dialogFormVisible = false;
            this.$message.success(`仓库信息修改成功！`);
          } else {
            this.$message.error(`仓库修改失败` + res.msg);
          }
        });
      }
    },
    //新增/编辑温湿度传感器提交
    submitTherm(data, isAdd) {
      this.ThermVisible = false;
      if (isAdd) {
        createTherm({ ...data }).then((res) => {
          if (res.code == "200") {
            this.getTInfo();
            this.$message.success("新增温湿度传感器成功！");
          } else {
            this.$message.error("新增失败！" + res.msg);
          }
        });
      } else {
        updateTherm(data).then((res) => {
          if (res.code == "200") {
            this.getTInfo();
            this.$message.success("温湿度传感器信息修改成功！");
          } else {
            this.$message.error("温湿度传感器信息修改失败！" + res.msg);
          }
        });
      }
    },
    //仓库编辑
    async edit(e) {
      this.isAdd = false;
      this.activeName='first'
      await getDepot(this.ckVal).then((res) => {
        if (res.code == "200") {
          this.propsForm = res.data;
          this.dialogFormVisible = true;
        } else {
          this.$message.error(res.msg || "获取仓库信息失败!");
        }
      });
    },
    thCancel() {
      this.thVisible = false;
    },
    thSubmit() {},
    showHkiMonitor() {
      let self = this;
      self.hkiMonModel.current = {};
      self.hkiMonModel.visible = true;
    },
  },
};
</script>

<style lang='less' scoped>
@import "~@/assets/css/commonStyle.less";
.popout2{
  /deep/ .el-dialog{
    margin-top: 1vh !important;
  }
  /deep/ .el-tabs__item{
    color: #74c8fe;
  }
  /deep/  .el-tabs__nav-wrap::after{
    background-color:#0c254000 !important;
  }
  /deep/  .el-dialog__body{
        padding-top: 0px !important;
  }


}
ul {
  list-style: none;
}
.router-link-active,
a {
  text-decoration: none;
}

.container_wh {
  // padding-right: 70px;
  display: flex;
  color: #74c8fe;
  .main_wh {
    // margin: 0 auto;
    // display: flex;
    display: flex;
    justify-content: space-between;
    width: 100%;
    .content_left {
      width: 170px;
      height: 783px;
      padding-top: 80px;
      .ckbtns {
        margin-bottom: 10px;
        width: 164px;
        border: 2px solid #018be9;
        border-radius: 6px;
        height: 30px;
        line-height: 30px;
        margin-bottom: 15px;
        text-align: center;
        cursor: pointer;
      }
    }
    .content_right {
      // flex: 1;
      width:  calc(100% - 170px);
      overflow-x: auto;
      .btns_wh {
        width: 100%;
        box-sizing: border-box;
        margin: 0 auto;
        // margin-right: 60px;
        // width:  calc(100% - 170px);
        .b_header {
          //面包屑导航
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 20px;
          margin-bottom: 10px;
          /deep/.el-breadcrumb__inner {
            color: #74c8fe;
          }
          /deep/ .el-breadcrumb__separator {
            color: #74c8fe;
          }
        }
        .cat-tab {
          display: flex;
          // justify-content: space-between;
          flex-direction: column;
          color: #74c8fe;
          margin-bottom: 25px;
          .left_btn {
            margin-right: 30px;
            div {
              width: 100px;
            }
            .el-button {
              width: 100px;
            }
          }
          .gzNumber {
            height: 30px;
            line-height: 30px;
            margin-right: 30px;
            font-size: 14px;
            border: 2px solid #018be9;
            border-radius: 6px;
            padding-right: 20px;
            display: flex;
            align-items: center;
            .icon-bg {
              margin-right: 10px;
              width: 30px;
              background: linear-gradient(
                180deg,
                rgba(49, 210, 255, 0.52),
                rgba(0, 57, 142, 0.52)
              );
              border-radius: 6px;
              border: 2px solid #018be9;
              text-align: center;
              position: relative;
              left: -2px;
              line-height: 28px;
              i {
                font-size: 20px;
              }
            }
          }
          .ck-info {
            display: flex;
            .wd {
              cursor: pointer;
            }
          }
        }
      }
    }
    //柜子部分样式
    .gz {
      margin-top: 20px;
      width: 100%;
      // width: 1630px;
      // width: calc( 100% - 60px);

    }
    .sideCk {
      float: left;
    }
  }
}

// 修改下拉框颜色
/deep/.el-select-dropdown__list {
  background: #092e5f !important;
  color: #74c8fe;
}
/deep/.el-select-dropdown__item {
  color: #74c8fe;
}
/deep/.el-select-dropdown {
  border: 2px solid#74c8fe;
}
/deep/.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #239cd3;
}
/deep/.el-popper[x-placement^="bottom"] .popper__arrow {
  top: -12px;
  border-bottom-color: #0090f0;
}
/deep/.el-popper[x-placement^="bottom"] .popper__arrow::after {
  top: -0px;
  border-bottom-color: #0090f0;
}
/deep/.el-select-dropdown__empty {
  background: #092e5f !important;
}

.not_info {
  margin: 0 auto;
  margin-top: 20px;
  width: 1570px;
  color: #74c8fe;
  font-size: 24px;
  text-align: center;
  .info_text {
    margin-top: 320px;
  }
}
.center_btn{
  margin-top: 10px;
  display: flex;
  align-items: center;
  margin-left: 60px;
}

</style>



// WEBPACK FOOTER //
// src/views/warehouse/index.vue